import { KeyboardEvent, useRef } from 'react';

interface IRangePointer {
    percent: number,
    onChangeCallback: Function,
    pointerClasses?: string,
}

const RangePointer = (props: IRangePointer) => {

    const { percent, pointerClasses } = props;

    // used to find the width of the pointer
    // and make its container a bit smaller,
    // so in the corner positions the whole pointer will be seen
    const pointerRef = useRef<HTMLDivElement>(null);

    /**
     * handle arrow
     */
    const onKeyDown = (evt: KeyboardEvent) => {

        switch (evt.key){
            case 'ArrowLeft': {
                props.onChangeCallback(Math.max(0, percent - 0.5));
                break;
            }

            case 'ArrowRight': {
                props.onChangeCallback(Math.min(100, percent + 0.5));
                break;
            }
        }
    };

    const handleClick = () => {
        if(!pointerRef || !pointerRef.current) return;
        pointerRef.current.focus();
    };

    return (
        <div className="absolute w-full h-full">
            <div
                className="absolute"
                style={{
                    left: `${ Math.round(percent) }%`,
                }}
            >
                <div
                    ref={ pointerRef }
                    tabIndex={ 0 }
                    onKeyDown={ onKeyDown }
                    onClick={ handleClick }
                    className={ `range-slider-pointer cursor-pointer ${ pointerClasses ? pointerClasses : '' }` }></div>
            </div>
        </div>
    )
};

export default RangePointer;